import React from "react";
import { useHistory } from "react-router-dom";
// Material imports
import HelpOutline from "@mui/icons-material/HelpOutline";
// Limitless imports
import { ClientContext } from "@limitless/common/utils";
import { useCustomerContext, useCustomerMessageContext } from "@limitless/customer/hooks";
import { Header, MessageHistoryList, NewMessageFooter } from "@limitless/customer/components";
import Toast from "@limitless/customer/components/toast/Toast";
import { useAppVisibilityContext } from "../hooks/app-visibility/AppVisibilityContext";
import { useCustomerAutoSubmit } from "../hooks/customer-auto-submit/CustomerAutoSubmitHook";
import { usePageViewRecorder } from "@limitless/analytics/hooks/AnalyticsPageViewRecorderHook";

const HistoryScreen = () => {
    const { toggleAppOpen } = useAppVisibilityContext();
    const history = useHistory();
    const { isSubject } = useCustomerAutoSubmit();
    const { updateHIWViewedStatus, isReturningCustomer } = useCustomerContext();
    const { fetchMessage, clearMessage } = useCustomerMessageContext();

    usePageViewRecorder("HistoryScreen");

    React.useEffect(() => {
        //when history screen loads, clear the current message
        clearMessage();
    }, []);

    const onHelpClick = () => {
        updateHIWViewedStatus(false);
        history.push("/");
    };

    const renderHeader = () => {
        if (ClientContext._hiwMode !== "disabled") {
            return (
                <Header
                    title="Conversation History"
                    leftIcon={<HelpOutline />}
                    onLeftIconClickHandle={onHelpClick}
                    onCloseHandle={toggleAppOpen}
                    id="conversationHistory"
                />
            );
        }

        return <Header id="conversationHistory" title="Conversation History" onCloseHandle={toggleAppOpen} />;
    };

    const onMessageHistoryClick = message => {
        fetchMessage(message.messageId, message.accessKey);
        history.push(`/conversation/${message.messageId}/${message.accessKey}/${true}`);
    };

    const navigateNewMessage = () => {
        //can happen if deeplinked from email but on a different browser
        if (isReturningCustomer() && isSubject) {
            history.push("/newMessage");
        } else {
            history.push("/createMessage");
        }
    };

    const canCreateNewMessage = ClientContext._newConversationMode === "standard" ? true : false;

    return (
        <div className="llm-view-container">
            {renderHeader()}
            <Toast />
            <MessageHistoryList onMessageHistoryClick={onMessageHistoryClick} />
            {canCreateNewMessage && <NewMessageFooter onButtonClick={navigateNewMessage} />}
        </div>
    );
};

export default HistoryScreen;
